export const REPORT_COLUMN_KEYS = Object.freeze({
  COMPONENT: 'component',
  CHANNEL: 'channel',
  MARKETPLACE_ID: 'marketplaceId',
  TYPE: 'type',
  PRODUCT_GROUP: 'productGroup',
  PRODUCT_LINE_NAME: 'productLineName',
  PARENT_PRODUCT_LINE_NAME: 'parentProductLineName',
});



// WEBPACK FOOTER //
// ./src/constants/report_columns.jsx